export default {
  personalize: {
    title: 'Personalize',
    subTitle: 'Make it more like yours',
    themes: 'Themes',
    font: 'Font Size',
    radius: 'Radius',
    normal: 'normal',
    medium: 'medium',
    large: 'large',
    'deep-theme': 'deep-theme',
    'devui-dark-theme': 'devui-dark-theme',
    'infinity-theme': 'infinity-theme',
    'provence-theme': 'provence-theme',
    'sweet-theme': 'sweet-theme',
    'customize-theme': 'customize-theme',
  },
};
